import React from 'react';
import { useIntl } from 'react-intl';
import ContentImage from '../Image/ContentImage';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import useImageCopyright from '../Image/useImageCopyright';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

export const HeroSchema = ({ intl }) => ({
  title: intl.formatMessage({ id: 'Hero', defaultMessage: 'Hero' }),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'alt', 'eyebrow', 'title', 'text'],
    },
  ],
  properties: {
    image: {
      title: intl.formatMessage({ id: 'Image', defaultMessage: 'Image' }),
      widget: 'object_browser',
      mode: 'image',
      selectedItemAttrs: ['Title', 'image_field', 'image_scales'],
    },
    alt: {
      title: intl.formatMessage({
        id: 'Alternative text',
        defaultMessage: 'Alternative text',
      }),
    },
    eyebrow: {
      title: intl.formatMessage({ id: 'Eyebrow', defaultMessage: 'Eyebrow' }),
    },
    title: {
      title: intl.formatMessage({ id: 'Title', defaultMessage: 'Title' }),
    },
    text: {
      title: intl.formatMessage({ id: 'Text', defaultMessage: 'Text' }),
      widget: 'textarea',
    },
  },
  required: ['title'],
});

export function HeroView({
  data,
  isEditMode = false,
  titleTag: Title = 'p',
  action = null,
}) {
  const intl = useIntl();
  const asset = data.image?.[0];
  const url = asset?.['@id'];
  const copyright = useImageCopyright(
    isEditMode ? url : undefined,
    data.copyright,
  );

  return (
    <div className="block bonn-hero">
      <div className="bonn-hero-backdrop">
        {
          <ContentImage
            fallback="hero"
            className="bonn-hero-image"
            item={asset?.image_scales ? asset : undefined}
            src={
              asset?.image_scales
                ? undefined
                : url
                  ? `${flattenToAppURL(url)}/@@images/image`
                  : undefined
            }
            alt={data.alt || ''}
            sizes="100vw"
          >
            {copyright && (
              <span className="bonn-hero-copyright">© {copyright}</span>
            )}
          </ContentImage>
        }
        <div className="bonn-hero-scrim" />
      </div>
      <div className="bonn-hero-info">
        {data.eyebrow && <p className="bonn-hero-eyebrow">{data.eyebrow}</p>}
        <Title className="bonn-hero-title">
          {data.title ||
            intl.formatMessage({
              id: 'Hero title',
              defaultMessage: 'Hero title',
            })}
        </Title>
        {data.text && <p className="bonn-hero-text">{data.text}</p>}
        {action}
      </div>
    </div>
  );
}

export function HeroEdit(props) {
  const {
    data,
    block,
    selected,
    onChangeBlock,
    blocksErrors,
    navRoot,
    contentType,
  } = props;
  const intl = useIntl();
  const schema = HeroSchema({ intl });
  return (
    <>
      <HeroView data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          onChangeBlock={onChangeBlock}
          errors={blocksErrors}
          navRoot={navRoot}
          contentType={contentType}
        />
      </SidebarPortal>
    </>
  );
}
